import appGlobalScript from '/tmp/scratch/ticom-feature-components_YYZEn/src/global/index.ts';
export const globalScripts = appGlobalScript;
